export default "__VITE_ASSET__EaJmblDw__"